import { isSameId } from "../../helpers";
export default function (store, ev) {
    const { id, project } = ev;
    if (!store.existsProject(id))
        return;
    let originalProject;
    const projects = store.getState().projects.map(p => {
        if (isSameId(id, p.id)) {
            originalProject = { ...p };
            return { ...p, ...project, id: p.id };
        }
        return p;
    });
    for (let key in project) {
        if (typeof originalProject[key] === "undefined") {
            originalProject[key] = null;
        }
    }
    store.setState({ projects });
    return () => {
        store.in.exec("update-project", {
            ...ev,
            project: originalProject,
            $meta: { skipHistory: true },
        });
    };
}
//# sourceMappingURL=update.js.map